import type { SecurityConfiguration as SecurityConfigurationModel } from '@/adapters/catalogv1.g';

export function extractSecurityConfiguration(
  model: SecurityConfigurationModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.config_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    category: model.category,
    key: model.key,
    value: model.value,
    valueType: model.value_type,
    isEnabled: model.is_enabled,
    scope: model.scope,
    lastModified: model.last_modified
      ? new Date(model.last_modified)
      : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogSecurityConfiguration = ReturnType<
  typeof extractSecurityConfiguration
>;
